import { useState } from "react";
import { topicWall } from "@/mocks/home";

const weightClass: Record<string, string> = {
  lg: "bg-primary-500 text-background-50 text-base px-4 py-2.5 border-primary-500",
  md: "bg-accent-100 text-accent-900 text-sm px-3.5 py-2 border-accent-300",
  sm: "bg-secondary-100 text-secondary-900 text-xs px-3 py-1.5 border-secondary-300",
};

export default function TopicWall() {
  const [selected, setSelected] = useState<string[]>([]);

  const toggle = (label: string) => {
    setSelected((prev) =>
      prev.includes(label) ? prev.filter((item) => item !== label) : [...prev, label],
    );
  };

  return (
    <section id="topic" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.24em] text-primary-600">
              <i className="ri-hashtag text-sm" />
              Topic Wall
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              话题墙 · 按热度聚合
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-7 text-foreground-600">
              字号与底色对应话题的聚合量，点击可加入筛选；已选话题会在下方汇总，方便对照不同分区的档案。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-3 text-[11px] text-foreground-500">
            <span className="flex items-center gap-1.5">
              <span className="h-2.5 w-2.5 rounded-sm bg-primary-500" />
              高频话题
            </span>
            <span className="flex items-center gap-1.5">
              <span className="h-2.5 w-2.5 rounded-sm bg-accent-300" />
              中频话题
            </span>
            <span className="flex items-center gap-1.5">
              <span className="h-2.5 w-2.5 rounded-sm bg-secondary-300" />
              长尾话题
            </span>
          </div>
        </div>

        <div className="grid gap-5 lg:grid-cols-12">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 lg:col-span-8">
            <div className="flex flex-wrap items-center gap-2.5">
              {topicWall.map((topic) => (
                <button
                  key={topic.label}
                  type="button"
                  onClick={() => toggle(topic.label)}
                  className={`flex items-center gap-1.5 rounded-md border font-medium transition-transform hover:-translate-y-0.5 ${
                    weightClass[topic.weight]
                  } ${selected.includes(topic.label) ? "ring-2 ring-primary-400 ring-offset-1" : ""}`}
                >
                  #{topic.label}
                  <span className="text-[11px] opacity-70">{topic.count}</span>
                </button>
              ))}
            </div>
          </div>

          <aside className="rounded-lg border border-background-200 bg-background-50 p-5 lg:col-span-4">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-filter-3-line text-base text-primary-600" />
              已选话题
            </h3>
            {selected.length === 0 ? (
              <p className="mt-3 rounded-md border border-dashed border-background-300 bg-background-100 px-3 py-6 text-center text-xs text-foreground-500">
                尚未选择话题，点击左侧标签加入筛选
              </p>
            ) : (
              <ul className="mt-3 space-y-2">
                {selected.map((label) => (
                  <li
                    key={label}
                    className="flex items-center justify-between rounded-md bg-primary-50 px-3 py-2 text-sm text-primary-800"
                  >
                    <span className="flex items-center gap-2">
                      <i className="ri-hashtag text-sm" />
                      {label}
                    </span>
                    <button type="button" onClick={() => toggle(label)} aria-label={`移除 ${label}`}>
                      <i className="ri-close-line text-base text-primary-600" />
                    </button>
                  </li>
                ))}
              </ul>
            )}
            <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
              <span>共 {topicWall.length} 个话题分区</span>
              <a href="#index" className="flex items-center gap-1 text-primary-700">
                进入索引
                <i className="ri-arrow-right-line text-sm" />
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}